import store from '../redux/store';

export const showAppPromotion = () => {
    const accountInfo = store.getState().account.account_info;

    if (
        accountInfo &&
        accountInfo.key === 'prospect' &&
        Object.prototype.hasOwnProperty.call(accountInfo, 'isLoginViaApp') &&
        !accountInfo.isLoginViaApp
    ) {
        return true;
    }

    return false;
};
